import React, {FC, useMemo, useState} from 'react';
import {MenuCategory, NavProduct, RootNavigation, SubCategory} from './category/Types';
import styles from './MenuItem.module.css';

const isProduct = (value: NavProduct | SubCategory[]): value is NavProduct => !Array.isArray(value)

const SubCategoryProduct: FC<{ value: NavProduct | SubCategory[] }> = (props) => {
    if (!isProduct(props.value)) {
        const subCategories = props.value; // ts knows props.value is SubCategory[]
        return (
            <ul>
                {subCategories.map((subCategory) => (
                    <li key={subCategory.id}>
                        <a href={subCategory.linkUrl}>{subCategory.name}</a>
                    </li>
                ))}
            </ul>
        )
    }
    const product = props.value; // ts knows props.value is NavProduct
    return (
        <div className={styles.recommendedProduct} title={product.name}>
            <span>Recommended Product</span>
            <h3>{product.name}</h3>
            <div className={styles.recommendedProductBody}>
                <div className={styles.recommendedProductDesc}>
                    <div>{product.descFirst}</div>
                    <div>{product.descSecond}</div>
                    <div>{product.descThird}</div>
                </div>
                <img src={product.imgUrl} alt={product.name} />
            </div>
            <div className={styles.recommendedProductPrice}>
                <span>only</span>
                <h2>{product.price}</h2>
            </div>
        </div>
    );
}

export const MenuItem: React.FC<RootNavigation> = ({categories, name}) => {
    const [menuCategory, setMenuCategory] = useState<MenuCategory | undefined>(undefined);
    const rightProduct = useMemo(() => menuCategory?.product || menuCategory?.subCategories, [menuCategory])
    return (
        <a href='/' className={styles.menuItem}>
            <span>{name}</span>
            <div className={styles.menuItemCategories}>
                <section className={styles.leftSide}>
                    <ul>
                        {categories.map((category) => (
                            <li key={category.id}
                                className={menuCategory?.id === category.id ? styles.leftSideCategorySelected : undefined}
                                onMouseEnter={() => setMenuCategory(category)}>
                                <a href={category.url}>{category.name}</a>
                            </li>

                        ))}
                    </ul>
                </section>
                {rightProduct && (
                    <section className={styles.rightSide}>
                        <SubCategoryProduct value={rightProduct}/>
                    </section>
                )}
            </div>
        </a>
    );
}
